// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const revertLanguageSelection = key => ({
    key,
    type: actions.UPDATE_USER_PREFERENCES_PRIMARY_LANGUAGE_KEY
});



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/revert-language-selection.js